import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import { Tooltip } from '@material-ui/core';

import BrIcons from '@components/BrIcons';
import BrLabel from '@components/BrLabel';

export default function VariantColumn({ row, col, cell }) {
  const handleOnClick = () => (cell.isColumnDisabled ? null : col.columnConfig.onClick(row));

  const variantCountClassName = cn('variant-count', {
    disabled: cell.isColumnDisabled,
  });

  const variantColumnWithoutHover = (
    <div onClick={handleOnClick}>
      <span className={variantCountClassName}>
        <BrLabel preIcon={(
          <div className="variant-container">
            <BrIcons.Variant2 />
            <div className="circle">
              <span>{cell.value}</span>
            </div>
          </div>
          )}
        />
      </span>
    </div>
  );

  const variantColumnWithHover = (
    <Tooltip title={cell.tooltipText} placement="top-start">
      <span className="inherit-all">{variantColumnWithoutHover}</span>
    </Tooltip>
  );

  return cell.tooltipText ? variantColumnWithHover : variantColumnWithoutHover;
}

VariantColumn.defaultWidth = 100;

VariantColumn.propTypes = {
  row: PropTypes.shape({
    Original_Data: PropTypes.shape({
      variants: PropTypes.any,
    }).isRequired,
  }).isRequired, // row data
  col: PropTypes.shape({
    // column config
    columnConfig: PropTypes.shape({
      onClick: PropTypes.func.isRequired, // (row, value:type) :=> {}
    }).isRequired, // this columnConfig is only required if it includes required properties
  }).isRequired,
  cell: PropTypes.shape({
    // cell data
    value: PropTypes.any,
    clickValue: PropTypes.any,
    isColumnDisabled: PropTypes.bool,
    tooltipText: PropTypes.string,
  }).isRequired,
};
